import { redirectMarketUrl } from '@libs/shared/src/common/constants';

import { Scenes } from '../../utils/enums/scenes';
import { SceneData } from '../../utils/types/scene';
import { GameScene } from '../classes/GameScene';
import { UI } from '../ui/ui';

export class ExitGame extends GameScene {
  private sceneData?: SceneData;

  constructor() {
    super(Scenes.EXIT_GAME);
  }

  init(data: SceneData) {
    this.sceneData = { ...data };
    this.user = data.user;
  }

  create() {
    this.input.setDefaultCursor('default');

    UI.images.Background(this);
    UI.text.ExitGameText(this);

    UI.buttons.PlayBtn(this, () => {
      this.scene.stop();

      if (this.sceneData?.level) {
        this.scene.resume(Scenes.GAME, { user: this.user });
      } else {
        this.scene.start(Scenes.GAME, { user: this.user });
      }
    });

    UI.buttons.ExitBtn(this, () => {
      window.location.href = redirectMarketUrl;
    });

    UI.icons.HomeIcon(this);

    if (this.sceneData?.level) {
      UI.text.Level(this, this.sceneData.level);
    }

    UI.icons.FullScreenIcon(this);
  }

  shutdownScene() {
    this.sceneData = undefined;
  }
}
